export class AbstractExternalAPIHandler {
  constructor(dm, hostAPI, manifestStore) {
    this.dm = dm;
    this.hostAPI = hostAPI;
    this.manifestStore = manifestStore;
  }
}
//# sourceMappingURL=AbstractExternalAPIHandler.js.map